export const toParisLocalInput = value => value ? new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
}).format(new Date(value)).replace(' ', 'T') : '';

export const closureLocalToIso = (value, original) => {
  const normalized = value.length === 16 ? `${value}:00` : value;
  if (original && toParisLocalInput(original) === normalized) return original;
  const utc = Date.parse(`${normalized}Z`);
  const candidates = [0, 60, 120, 180].map(offset => new Date(utc - offset * 60000))
    .filter(date => !Number.isNaN(date.getTime()) && toParisLocalInput(date.toISOString()) === normalized);
  if (candidates.length !== 1) throw new Error('Horaire inexistant ou ambigu au changement d’heure de Paris. Choisissez un horaire non ambigu.');
  return candidates[0].toISOString();
};